import React from 'react';
import { useState, useEffect } from "react";

import AddButton from '../UI/AddButton/AddButton';
import TodoAddInput from '../UI/TodoAddInput/TodoAddInput';

import { TodoCreationWrapperStyled } from './TodoCreation.styled';

import { v4 as uuidv4 } from 'uuid';

const TodoCreation = () => {
    const [input, setInput] = useState('');
    const [todoList, setTodoList] = useState([]);

    useEffect(() => {
      if(localStorage.getItem('todoList')) {
        setTodoList(JSON.parse(localStorage.getItem('todoList')));
      }
    }, [])


  const handleClick = () => {
    if(input) {
      setTodoList([
        ...todoList,
        {
          id: uuidv4(),
          text: input,
          completed: false,
          creationDate: `${Date.now()}`
        }
      ]);

      setInput('');
    }
  }

  const handleEnterPress = (e) => {
    if(e.key === 'Enter') {
      handleClick();
    }
  }

  useEffect(() => {
    if(todoList.length > 0) {
      localStorage.setItem('todoList', JSON.stringify(todoList));
    }
  }, [todoList])

    return <>
      <TodoCreationWrapperStyled>
      <TodoAddInput 
        type="text"
        value={input}
        onInput={e => setInput(e.target.value)}
        onKeyDown={handleEnterPress}
      />
      {
        (input.length > 0) ? <AddButton 
        onClick={() => handleClick()}
      /> : null
      }
      </TodoCreationWrapperStyled>
    </>
}

export default TodoCreation;